module.exports = __webpack_public_path__ + "media/images/emblems/Tramelan-coat_of_arms-61873a15822121f24c382954a77a9daf.svg";